// SingleprojectDetail and SingleProductDetail moved to /data/projects and /data/products (fetched at runtime)
// See src/utils/fetchProjectData.js and fetchProductData.js for how to load them

export const ProductImages = [
  {
    "imgPath": "assets/Allproducts/MetaParametric/metacoin/cover/metacoin.webp",
    "imgText": "MetaCoin",
    "order": 1
  },
  {
    "imgPath": "assets/Allproducts/MetaParametric/metasequin/cover/metasequin1.webp",
    "imgText": "MetaSequin",
    "order": 2
  },
  {
    "imgPath": "assets/Allproducts/MetaForm/metacassette/cover/metacassette.webp",
    "imgText": "MetaCassette",
    "order": 3
  },
  {
    "imgPath": "assets/Allproducts/MetaForm/metapyramid/cover/metapyramid.webp",
    "imgText": "MetaPyramid",
    "order": 4
  },
  {
    "imgPath": "assets/Allproducts/MetaForm/metashingle/cover/metashingle.webp",
    "imgText": "MetaShingles",
    "order": 5
  },
  {
    "imgPath": "assets/Allproducts/MetaForm/CascadingKeys/cover/caskey1.webp",
    "imgText": "Cascading Keys",
    "order": 6
  },
  {
    "imgPath": "assets/Allproducts/MetaForm/SolidPanel/cover/solidpanel.webp",
    "imgText": "SolidPanel",
    "order": 7
  },
  {
    "imgPath": "assets/Allproducts/MetaForm/metaflute/cover/metaflute.webp",
    "imgText": "MetaFlute",
    "order": 8
  },
  {
    "imgPath": "assets/Allproducts/MetaParametric/metafin/cover/metafin.webp",
    "imgText": "MetaFin",
    "order": 9
  },
  {
    "imgPath": "assets/Allproducts/MetaFunction/metafold/cover/metafold1.webp",
    "imgText": "MetaFold",
    "order": 10
  },
  {
    "imgPath": "assets/Allproducts/MetaFunction/metaslider/cover/metaslider.webp",
    "imgText": "MetaSlider",
    "order": 11
  },
  {
    "imgPath": "assets/Allproducts/MetaForm/metaplank/cover/metaplank.webp",
    "imgText": "MetaPlank",
    "order": 12
  },
  {
    "imgPath": "assets/Allproducts/MetaFunction/metagate/cover/metagate4.webp",
    "imgText": "MetaGate",
    "order": 13
  },
  {
    "imgPath": "assets/Allproducts/MetaSurface/metacopper/cover/metacopper1.webp",
    "imgText": "MetaCopper",
    "order": 14
  },
  {
    "imgPath": "assets/Allproducts/MetaSurface/metapatina/cover/metapatina.webp",
    "imgText": "MetaPatina",
    "order": 15
  },
  {
    "imgPath": "assets/Allproducts/MetaSurface/metacorten/cover/metacorten3.webp",
    "imgText": "MetaCorten",
    "order": 16
  },
  {
    "imgPath": "assets/Allproducts/MetaSurface/metagrey/cover/metagrey.webp",
    "imgText": "MetaGrey",
    "order": 17
  },
  {
    "imgPath": "assets/Allproducts/MetaSurface/metawood/cover/metawood.webp",
    "imgText": "MetaWood",
    "order": 18
  },
  {
    "imgPath": "assets/Allproducts/MetaParametric/metahydra/cover/metahydra.webp",
    "imgText": "MetaHydra",
    "order": 19
  },
  {
    "imgPath": "assets/Allproducts/MetaParametric/metablox/cover/metablox.webp",
    "imgText": "MetaBlox",
    "order": 20
  },
  {
    "imgPath": "assets/Allproducts/MetaForm/metalouver/cover/metalouver.webp",
    "imgText": "MetaLouver",
    "order": 21
  },
  {
    "imgPath": "assets/Allproducts/MetaParametric/metahive/metahive1.png",
    "imgText": "MetaHive",
    "order": 22
  },
  {
    "imgPath": "assets/Allproducts/MetaForm/Metacryst/metacryst1.png",
    "imgText": "MetaCryst",
    "order": 23
  }
];

export const ProjectImages = [
  {
    "imgPath": "assets/Allprojects/commercial/Miraj Stadium/cover/miraj (1).webp",
    "order": 1,
    "alt": "Miraj Stadium exterior facade design"
  },

    {
    "imgPath": "assets/Allprojects/commercial/Zoee Nails/cover/zoe1.webp",
    "order": 1,
    "alt": "Zoee Nails' illuminated retail facade glows above Rajouri Garden at dusk."
  },

   {
    "imgPath": "assets/Allprojects/commercial/AEK/cover/aek1.webp",
    "order": 1,
    "alt": "Champagne gold sequin panel facade on AEK Signature Spaces, Golf Course Road, Gurugram"
  },

    {
    "imgPath": "assets/Allprojects/commercial/Radiance/cover/Day-1.webp",
    "order": 1,
    "alt": "Champagne gold metal facade on Hotel Radiance's commercial elevation in Sirsa, its MetaCoin pattern in daylight."
  },


  {
    "imgPath": "assets/Allprojects/commercial/AB Jewels/cover/ab_1.webp",
    "order": 1,
    "alt": "AB Jewels facade design by Metaguise"
  },
  {
    "imgPath": "assets/Allprojects/commercial/whiteland/cover/wl1.webp",
    "order": 1,
    "alt": "White Land metal facade project by Metaguise"
  },
  {
    "imgPath": "assets/Allprojects/residential/The Block/cover/The Block (8).webp",
    "order": 1,
    "alt": "The Block luxury residential facade with MetaCassette and MetaLouver cladding by Metaguise"
  },
  {
    "imgPath": "assets/Allprojects/commercial/Hadapsar/cover/Hadapsar (5).webp",
    "order": 1,
    "alt": "The Block luxury commercial facade with MetaCassette and MetaLouver cladding by Metaguise"
  },
  {
    "imgPath": "assets/Allprojects/residential/Rhythm Goel/cover/The Overhang (1).webp",
    "order": 1,
    "alt": "The Block luxury residential facade with MetaCassette and MetaLouver cladding by Metaguise"
  },
  {
    "imgPath": "assets/Allprojects/commercial/ahir/cover/x (9).webp",
    "order": 1,
    "alt": "Ahir commercial building facade with MetaCoin parametric metal cladding by Metaguise, India"
  },
  {
    "imgPath": "assets/Allprojects/commercial/Sohana/cover/Sohana Hospital (9).webp",
    "order": 1,
    "alt": "Sohana Hospital exterior facade with perforated MetaCassette cladding in MetaGrey by Metaguise"
  },
  {
    "imgPath": "assets/Allprojects/commercial/GLSU/cover/GLS University (12).webp",
    "order": 1,
    "alt": "GLS University building facade with MetaCassette perforated cladding by Metaguise India"
  },
  {
    "imgPath": "assets/Allprojects/residential/The Canopy/cover/canopy (1).webp",
    "order": 1,
    "alt": "The Canopy luxury residential facade with MetaCassette and MetaLouver cladding by Metaguise"
  },
  {
    "imgPath": "assets/Allprojects/commercial/wvcity/cover/wv1.webp",
    "order": 1,
    "alt": "Wave City facade project by Metaguise with modern metal facade design"
  },
  {
    "imgPath": "assets/Allprojects/residential/3939A/cover/3939A_7.webp",
    "order": 1,
    "alt": "Scaled Symphony metal facade project by Metaguise"
  },
  {
    "imgPath": "assets/Allprojects/commercial/Fortis/cover/Fortis (1).webp",
    "order": 1,
    "alt": "facade project by Metaguise featuring modern metal architecture"
  },
  {
    "imgPath": "assets/Allprojects/commercial/RJJewellers/cover/rj1.webp",
    "order": 1,
    "alt": "RJ Jewellers commercial project cover - Jewelry store with elegant metal facade design"
  },
  {
    "imgPath": "assets/Allprojects/residential/Sculpted Silence/cover/A2_1.webp",
    "order": 1,
    "alt": "Sculpted Silence residential project cover - Parametric metal shingle facade front view"
  },
  {
    "imgPath": "assets/Allprojects/residential/The Pavilion/cover/The Pavilion (1).webp",
    "order": 1,
    "alt": "The Pavilion facade project by Metaguise"
  },
  {
    "imgPath": "assets/Allprojects/residential/The Solace/cover/The Solace (1).webp",
    "order": 1,
    "alt": "The Solace facade project by Metaguise"
  },
  {
    "imgPath": "assets/Allprojects/residential/The Strata/cover/The Strata (1).webp",
    "order": 1,
    "alt": "The Strata facade project by Metaguise"
  },
  {
    "imgPath": "assets/Allprojects/residential/The Podium/cover/The Podium (1).webp",
    "order": 1,
    "alt": "The Podium facade project by Metaguise"
  },
  {
    "imgPath": "assets/Allprojects/residential/The Scale/cover/The Scale (1).webp",
    "order": 1,
    "alt": "The Scale facade project by Metaguise"
  },
  {
    "imgPath": "assets/Allprojects/residential/The Ripple/cover/The Ripple (1).webp",
    "order": 1,
    "alt": "The Ripple facade project by Metaguise"
  },
  {
    "imgPath": "assets/Allprojects/residential/The Nest/cover/The Nest (1).webp",
    "order": 1,
    "alt": "The Nest facade project by Metaguise"
  },
  {
    "imgPath": "assets/Allprojects/residential/The Spine/cover/The Spine (1).webp",
    "order": 1,
    "alt": "The Spine metal facade project by Metaguise"
  },
  {
    "imgPath": "assets/Allprojects/residential/The Cantilever/cover/The Cantilever (1).webp",
    "order": 1,
    "alt": "The Cantilever metal facade project by Metaguise"
  },
  {
    "imgPath": "assets/Allprojects/residential/The Crest/cover/The Crest (1).webp",
    "order": 1,
    "alt": "The Crest metal facade project by Metaguise"
  },
  {
    "imgPath": "assets/Allprojects/residential/The Frame/cover/The Frame (1).webp",
    "order": 1,
    "alt": "The Frame metal facade project by Metaguise"
  },
  {
    "imgPath": "assets/Allprojects/residential/The Panorama/cover/The Panorama (1).webp",
    "order": 1,
    "alt": "The Panorama facade project by Metaguise"
  },
  {
    "imgPath": "assets/Allprojects/commercial/Rahul Sweets/cover/Rahul Sweets (1).webp",
    "order": 1,
    "alt": "Rahul Sweets commercial facade design by Metaguise"
  },
  {
    "imgPath": "assets/Allprojects/commercial/Achintya/cover/achintya_1.webp",
    "order": 1,
    "alt": "Achintya architectural facade project by Metaguise"
  },
  {
    "imgPath": "assets/Allprojects/residential/Casa Stilgrove/cover/casa_1.webp",
    "order": 1,
    "alt": "Casa Stilgrove facade project by Metaguise"
  },
  {
    "imgPath": "assets/Allprojects/residential/The Cornerstone/cover/nitiKa_1.webp",
    "order": 1,
    "alt": "The Cornerstone facade project by Metaguise"
  },
  {
    "imgPath": "assets/Allprojects/residential/The Golden Bloom/cover/coin_1.webp",
    "order": 1,
    "alt": "The Golden Bloom metal facade project by Metaguise"
  },
  {
    "imgPath": "assets/Allprojects/residential/The Stillwave/cover/Kunal_1.webp",
    "order": 1,
    "alt": "The Stillwave metal facade project by Metaguise"
  },
  {
    "imgPath": "assets/Allprojects/residential/The Haven/cover/rochak_1.webp",
    "order": 1,
    "alt": " The Haven contemporary facade project by Metaguise"
  },
  {
    "imgPath": "assets/Allprojects/residential/Apex Residence/cover/manish_1.webp",
    "order": 1,
    "alt": " Apex Residence residential facade design by Metaguise"
  },
  {
    "imgPath": "assets/Allprojects/commercial/Blossoms/cover/blossoms1.webp",
    "order": 1,
    "alt": "Blossoms commercial project cover - Commercial space with blossoming architectural design"
  },
  {
    "imgPath": "assets/Allprojects/commercial/Cityspace82/cover/cityspace82_1.webp",
    "order": 1,
    "alt": "Cityspace82 commercial project cover - Urban commercial development with metal facade"
  },
  {
    "imgPath": "assets/Allprojects/residential/88Arjun/cover/88_5.webp",
    "order": 1,
    "alt": "Parametric Crown metal facade design by Metaguise"
  },
  {
    "imgPath": "assets/Allprojects/residential/Verdigris Veil/cover/K3_1.webp",
    "order": 1,
    "alt": "Verdigris Veil architectural facade by Metaguise"
  },
  {
    "imgPath": "assets/Allprojects/residential/W12/cover/w12_1.webp",
    "order": 1,
    "alt": "W12 residential project cover - Contemporary villa with metal cladding system"
  },
  {
    "imgPath": "assets/Allprojects/residential/caskey/cover/caskey1.webp",
    "order": 1,
    "alt": "Kinetic Grid facade project by Metaguise"
  },
  {
    "imgPath": "assets/Allprojects/commercial/hlp/cover/hlp1.webp",
    "order": 1,
    "alt": "HLP metal facade project designed by Metaguise"
  },
  {
    "imgPath": "assets/Allprojects/commercial/sbi/cover/sbi1.webp",
    "order": 1,
    "alt": "SBI Bank facade design project by Metaguise"
  },
  {
    "imgPath": "assets/Allprojects/commercial/zenith/cover/zen1.webp",
    "order": 1,
    "alt": "Zenith architectural facade project by Metaguise"
  },
  {
    "imgPath": "assets/Allprojects/residential/3DLF1/cover/3dlf1_1.webp",
    "order": 1,
    "alt": "3DLF architectural facade project by Metaguise"
  },
  {
    "imgPath": "assets/Allprojects/residential/anj/cover/anj1.webp",
    "order": 1,
    "alt": "ANJ residential project cover - Modern home with custom metal shingle design"
  },
  {
    "imgPath": "assets/Allprojects/residential/pritesh/cover/pritesh1.webp",
    "order": 1,
    "alt": "Sacred Geometry metal facade design by Metaguise"
  },
  {
    "imgPath": "assets/Allprojects/residential/ishaan/cover/ishaan1.webp",
    "order": 1,
    "alt": "Peacock mesh metal facade design by Metaguise"
  },
  {
    "imgPath": "assets/Allprojects/residential/sachi/cover/sachi1.webp",
    "order": 1,
    "alt": "Sachi architectural facade project by Metaguise"
  },
  {
    "imgPath": "assets/Allprojects/residential/vivek/cover/vivek1.webp",
    "order": 1,
    "alt": "Obsidian architectural facade project by Metaguise"
  },
  {
    "imgPath": "assets/Allprojects/residential/dev622/cover/dev1.webp",
    "order": 1,
    "alt": "Monolith Garden architectural facade project by Metaguise"
  },
  {
    "imgPath": "assets/Allprojects/residential/PeachStreet/cover/peachstreet1.webp",
    "order": 1,
    "alt": "Peach Street architectural facade project by Metaguise"
  },
  {
    "imgPath": "assets/Allprojects/residential/CopperCanvas/cover/coppercanvas1.webp",
    "order": 1,
    "alt": "Copper facade design project Copper Canvas by Metaguise"
  },
  {
    "imgPath": "assets/Allprojects/residential/LinearRetreat/cover/linearretreat1.webp",
    "order": 1,
    "alt": "Linear Retreat architectural facade project by Metaguise"
  },
  {
    "imgPath": "assets/Allprojects/residential/TheResonance/cover/karan1.webp",
    "order": 1,
    "alt": "The Resonance residential project cover - Home with resonant metal architectural elements"
  },
  {
    "imgPath": "assets/Allprojects/residential/TheElevato/cover/neeraj1.webp",
    "order": 1,
    "alt": "The Elevato residential project cover - Elevated design with modern metal facade"
  },
  {
    "imgPath": "assets/Allprojects/commercial/TheCurtain/cover/vega1.webp",
    "order": 1,
    "alt": "The Curtain commercial project cover - Curtain-inspired metal facade for commercial space"
  },
  {
    "imgPath": "assets/Allprojects/residential/TheCrystal/cover/bikaner1.webp",
    "order": 1,
    "alt": "The Crystal residential project cover - Crystal-inspired architecture with metal cladding"
  },
  {
    "imgPath": "assets/Allprojects/residential/Farm15/cover/farm1.webp",
    "order": 1,
    "alt": "Farm15 residential project cover - Farmhouse with contemporary metal architecture"
  },
  {
    "imgPath": "assets/Allprojects/residential/E81/cover/e81_1.webp",
    "order": 1,
    "alt": "E81 residential project cover - Modern residence with parametric metal facade"
  },
  {
    "imgPath": "assets/Allprojects/residential/B38/cover/b38_1.webp",
    "order": 1,
    "alt": "B38 residential project cover - Contemporary home with custom metal cladding"
  },
  {
    "imgPath": "assets/Allprojects/residential/A56/cover/a56_1.webp",
    "order": 1,
    "alt": "A56 residential project cover - Modern villa with architectural metal design"
  },
  {
    "imgPath": "assets/Allprojects/commercial/Ardete/cover/ardete5.webp",
    "order": 1,
    "alt": "Ardete commercial project cover - Commercial building with innovative metal facade"
  },
  {
    "imgPath": "assets/Allprojects/residential/TheWaveform/cover/khandelwal1.webp",
    "order": 1,
    "alt": "The Waveform residential project cover - Wave-inspired metal architecture for modern home"
  },
  {
    "imgPath": "assets/Allprojects/commercial/Tanishq/cover/tanishq11.webp",
    "order": 2,
    "alt": "Tanishq commercial project cover - Jewelry showroom with premium metal architecture"
  },
  {
    "imgPath": "assets/Allprojects/residential/Luxe/cover/luxe16.webp",
    "order": 3,
    "alt": "Luxe residential project cover - Luxury residence with premium metal facade"
  },
  {
    "imgPath": "assets/Allprojects/residential/D5-3/cover/ankit1.webp",
    "order": 4,
    "alt": "D5-3 residential project cover - Contemporary home with metal shingle facade"
  },
  {
    "imgPath": "assets/Allprojects/commercial/Gowri/cover/gowri2.webp",
    "order": 5,
    "alt": "Gowri commercial project cover - Commercial space with elegant metal cladding"
  },
  {
    "imgPath": "assets/Allprojects/residential/Espace/cover/espace1.webp",
    "order": 6,
    "alt": "Espace residential project cover - Spacious residence with modern metal design"
  },
  {
    "imgPath": "assets/Allprojects/residential/A13-43/cover/a13-431.webp",
    "order": 7,
    "alt": "A13-43 residential project cover - Modern residence with geometric metal patterns"
  },
  {
    "imgPath": "assets/Allprojects/residential/Q62-RA/cover/tejbir1.webp",
    "order": 8,
    "alt": "Q62-RA residential project cover - Contemporary residence with metal cladding design"
  },
  {
    "imgPath": "assets/Allprojects/commercial/PremHospital/cover/prem1.webp",
    "order": 10,
    "alt": "Prem Hospital commercial project cover - Healthcare facility with contemporary metal facade"
  },
  {
    "imgPath": "assets/Allprojects/residential/A18/cover/a181.webp",
    "order": 11,
    "alt": "A18 residential project cover - Contemporary villa with metal facade system"
  },
  {
    "imgPath": "assets/Allprojects/commercial/Painflame/cover/15.webp",
    "order": 12,
    "alt": "Painflame commercial project cover - Commercial space with innovative metal design"
  },
  {
    "imgPath": "assets/Allprojects/commercial/Deepak/cover/deepak1.webp",
    "order": 14,
    "alt": "Deepak commercial project cover - Modern commercial building with metal accents"
  },
  {
    "imgPath": "assets/Allprojects/residential/A19/cover/a192.webp",
    "order": 18,
    "alt": "A19 residential project cover - Luxury residence with parametric metal design"
  },
  {
    "imgPath": "assets/Allprojects/residential/MVA-DL1/cover/varun5.webp",
    "alt": "MVA-DL1 residential project cover - Modern home with custom metal shingle design"
  },
  {
    "imgPath": "assets/Allprojects/residential/CS5-MA/cover/vishal1.webp",
    "order": 15,
    "alt": "CS5-MA residential project cover - Contemporary home with metal shingle architecture"
  },
  {
    "imgPath": "assets/Allprojects/commercial/Metaland/cover/metaland6.webp",
    "order": 20,
    "alt": "Metaland commercial project cover - Commercial development with extensive metal architecture"
  },
  {
    "imgPath": "assets/Allprojects/commercial/Micasa/cover/micasa1.webp",
    "order": 21,
    "alt": "Micasa commercial project cover - Modern commercial space with metal cladding"
  },
  {
    "imgPath": "assets/Allprojects/commercial/yashika/cover/yashika1.webp",
    "alt": "Yashika commercial project cover - Commercial building with contemporary metal facade"
  },
  {
    "imgPath": "assets/Allprojects/residential/5107/cover/51071.webp",
    "order": 13,
    "alt": "5107 residential project cover - Contemporary home with parametric metal shingles"
  },
  {
    "imgPath": "assets/Allprojects/residential/A297/cover/a2971.webp",
    "order": 16,
    "alt": "A297 residential project cover - Luxury villa with architectural metal facade"
  },
  {
    "imgPath": "assets/Allprojects/commercial/E10/cover/e105.webp",
    "order": 17,
    "alt": "E10 commercial project cover - Modern commercial building with metal architecture"
  },
  {
    "imgPath": "assets/Allprojects/residential/C76/cover/c7615.webp",
    "order": 22,
    "alt": "C76 residential project cover - Modern residence with textured metal design"
  },
  {
    "imgPath": "assets/Allprojects/residential/C34-573/cover/kapil1.webp",
    "order": 23,
    "alt": "C34-573 residential project cover - Modern home with custom metal cladding system"
  },
  {
    "imgPath": "assets/Allprojects/residential/DLF4/cover/dlf44.webp",
    "order": 24,
    "alt": "DLF4 residential project cover - Premium residence with elegant metal facade"
  },
  {
    "imgPath": "assets/Allprojects/residential/MA-543/cover/manoj1.webp",
    "order": 25,
    "alt": "MA-543 residential project cover - Modern villa with parametric metal facade"
  },
  {
    "imgPath": "assets/Allprojects/residential/z1012/cover/z10121.webp",
    "order": 26,
    "alt": "Z1012 residential project cover - Modern home with geometric metal patterns"
  }
];

export const products = [
  {
    "id": 1,
    "name": "Metacoin",
    "slug": "metacoin"
  },
  {
    "id": 2,
    "name": "Metasequin",
    "slug": "metasequin"
  },
  {
    "id": 3,
    "name": "Cascading Keys",
    "slug": "cascading-keys"
  },
  {
    "id": 4,
    "name": "Metashingles",
    "slug": "metashingles"
  },
  {
    "id": 5,
    "name": "MetaHive",
    "slug": "metahive"
  },
  {
    "id": 6,
    "name": "MetaCryst",
    "slug": "metacryst"
  }
];

export const sortedProductImages = [
  {
    "imgPath": "assets/Allproducts/MetaParametric/metacoin/cover/metacoin.webp",
    "imgText": "MetaCoin",
    "order": 1
  },
  {
    "imgPath": "assets/Allproducts/MetaParametric/metasequin/cover/metasequin1.webp",
    "imgText": "MetaSequin",
    "order": 2
  },
  {
    "imgPath": "assets/Allproducts/MetaForm/metacassette/cover/metacassette.webp",
    "imgText": "MetaCassette",
    "order": 3
  },
  {
    "imgPath": "assets/Allproducts/MetaForm/metapyramid/cover/metapyramid.webp",
    "imgText": "MetaPyramid",
    "order": 4
  },
  {
    "imgPath": "assets/Allproducts/MetaForm/metashingle/cover/metashingle.webp",
    "imgText": "MetaShingles",
    "order": 5
  },
  {
    "imgPath": "assets/Allproducts/MetaForm/CascadingKeys/cover/caskey1.webp",
    "imgText": "Cascading Keys",
    "order": 6
  },
  {
    "imgPath": "assets/Allproducts/MetaForm/SolidPanel/cover/solidpanel.webp",
    "imgText": "SolidPanel",
    "order": 7
  },
  {
    "imgPath": "assets/Allproducts/MetaForm/metaflute/cover/metaflute.webp",
    "imgText": "MetaFlute",
    "order": 8
  },
  {
    "imgPath": "assets/Allproducts/MetaParametric/metafin/cover/metafin.webp",
    "imgText": "MetaFin",
    "order": 9
  },
  {
    "imgPath": "assets/Allproducts/MetaFunction/metafold/cover/metafold1.webp",
    "imgText": "MetaFold",
    "order": 10
  },
  {
    "imgPath": "assets/Allproducts/MetaFunction/metaslider/cover/metaslider.webp",
    "imgText": "MetaSlider",
    "order": 11
  },
  {
    "imgPath": "assets/Allproducts/MetaForm/metaplank/cover/metaplank.webp",
    "imgText": "MetaPlank",
    "order": 12
  },
  {
    "imgPath": "assets/Allproducts/MetaFunction/metagate/cover/metagate4.webp",
    "imgText": "MetaGate",
    "order": 13
  },
  {
    "imgPath": "assets/Allproducts/MetaSurface/metacopper/cover/metacopper1.webp",
    "imgText": "MetaCopper",
    "order": 14
  },
  {
    "imgPath": "assets/Allproducts/MetaSurface/metapatina/cover/metapatina.webp",
    "imgText": "MetaPatina",
    "order": 15
  },
  {
    "imgPath": "assets/Allproducts/MetaSurface/metacorten/cover/metacorten3.webp",
    "imgText": "MetaCorten",
    "order": 16
  },
  {
    "imgPath": "assets/Allproducts/MetaSurface/metagrey/cover/metagrey.webp",
    "imgText": "MetaGrey",
    "order": 17
  },
  {
    "imgPath": "assets/Allproducts/MetaSurface/metawood/cover/metawood.webp",
    "imgText": "MetaWood",
    "order": 18
  },
  {
    "imgPath": "assets/Allproducts/MetaParametric/metahydra/cover/metahydra.webp",
    "imgText": "MetaHydra",
    "order": 19
  },
  {
    "imgPath": "assets/Allproducts/MetaParametric/metablox/cover/metablox.webp",
    "imgText": "MetaBlox",
    "order": 20
  },
  {
    "imgPath": "assets/Allproducts/MetaForm/metalouver/cover/metalouver.webp",
    "imgText": "MetaLouver",
    "order": 21
  },
  {
    "imgPath": "assets/Allproducts/MetaParametric/metahive/metahive1.png",
    "imgText": "MetaHive",
    "order": 22
  },
  {
    "imgPath": "assets/Allproducts/MetaForm/Metacryst/metacryst1.png",
    "imgText": "MetaCryst",
    "order": 23
  }
];

export const sortedProjects = [
  {
    "imgPath": "assets/Allprojects/commercial/Miraj Stadium/cover/miraj (1).webp",
    "order": 1,
    "alt": "Miraj Stadium exterior facade design"
  },
  {
    "imgPath": "assets/Allprojects/commercial/AB Jewels/cover/ab_1.webp",
    "order": 1,
    "alt": "AB Jewels facade design by Metaguise"
  },
  {
    "imgPath": "assets/Allprojects/commercial/whiteland/cover/wl1.webp",
    "order": 1,
    "alt": "White Land metal facade project by Metaguise"
  },
  {
    "imgPath": "assets/Allprojects/residential/The Block/cover/The Block (8).webp",
    "order": 1,
    "alt": "The Block luxury residential facade with MetaCassette and MetaLouver cladding by Metaguise"
  },
  {
    "imgPath": "assets/Allprojects/residential/Hadapsar/cover/Hadapsar (5).webp",
    "order": 1,
    "alt": "The Block luxury residential facade with MetaCassette and MetaLouver cladding by Metaguise"
  },
  {
    "imgPath": "assets/Allprojects/residential/Rhythm Goel/cover/The Overhang (1).webp",
    "order": 1,
    "alt": "The Block luxury residential facade with MetaCassette and MetaLouver cladding by Metaguise"
  },
  {
    "imgPath": "assets/Allprojects/commercial/ahir/cover/x (9).webp",
    "order": 1,
    "alt": "Ahir commercial building facade with MetaCoin parametric metal cladding by Metaguise, India"
  },
  {
    "imgPath": "assets/Allprojects/commercial/Sohana/cover/Sohana Hospital (9).webp",
    "order": 1,
    "alt": "Sohana Hospital exterior facade with perforated MetaCassette cladding in MetaGrey by Metaguise"
  },
  {
    "imgPath": "assets/Allprojects/commercial/GLSU/cover/GLS University (12).webp",
    "order": 1,
    "alt": "GLS University building facade with MetaCassette perforated cladding by Metaguise India"
  },
  {
    "imgPath": "assets/Allprojects/residential/The Canopy/cover/canopy (1).webp",
    "order": 1,
    "alt": "The Canopy luxury residential facade with MetaCassette and MetaLouver cladding by Metaguise"
  },
  {
    "imgPath": "assets/Allprojects/commercial/wvcity/cover/wv1.webp",
    "order": 1,
    "alt": "Wave City facade project by Metaguise with modern metal facade design"
  },
  {
    "imgPath": "assets/Allprojects/residential/3939A/cover/3939A_7.webp",
    "order": 1,
    "alt": "Scaled Symphony metal facade project by Metaguise"
  },
  {
    "imgPath": "assets/Allprojects/commercial/Fortis/cover/Fortis (1).webp",
    "order": 1,
    "alt": "facade project by Metaguise featuring modern metal architecture"
  },
  {
    "imgPath": "assets/Allprojects/commercial/RJJewellers/cover/rj1.webp",
    "order": 1,
    "alt": "RJ Jewellers commercial project cover - Jewelry store with elegant metal facade design"
  },
  {
    "imgPath": "assets/Allprojects/residential/Sculpted Silence/cover/A2_1.webp",
    "order": 1,
    "alt": "Sculpted Silence residential project cover - Parametric metal shingle facade front view"
  },
  {
    "imgPath": "assets/Allprojects/residential/The Pavilion/cover/The Pavilion (1).webp",
    "order": 1,
    "alt": "The Pavilion facade project by Metaguise"
  },
  {
    "imgPath": "assets/Allprojects/residential/The Solace/cover/The Solace (1).webp",
    "order": 1,
    "alt": "The Solace facade project by Metaguise"
  },
  {
    "imgPath": "assets/Allprojects/residential/The Strata/cover/The Strata (1).webp",
    "order": 1,
    "alt": "The Strata facade project by Metaguise"
  },
  {
    "imgPath": "assets/Allprojects/residential/The Podium/cover/The Podium (1).webp",
    "order": 1,
    "alt": "The Podium facade project by Metaguise"
  },
  {
    "imgPath": "assets/Allprojects/residential/The Scale/cover/The Scale (1).webp",
    "order": 1,
    "alt": "The Scale facade project by Metaguise"
  },
  {
    "imgPath": "assets/Allprojects/residential/The Ripple/cover/The Ripple (1).webp",
    "order": 1,
    "alt": "The Ripple facade project by Metaguise"
  },
  {
    "imgPath": "assets/Allprojects/residential/The Nest/cover/The Nest (1).webp",
    "order": 1,
    "alt": "The Nest facade project by Metaguise"
  },
  {
    "imgPath": "assets/Allprojects/residential/The Spine/cover/The Spine (1).webp",
    "order": 1,
    "alt": "The Spine metal facade project by Metaguise"
  },
  {
    "imgPath": "assets/Allprojects/residential/The Cantilever/cover/The Cantilever (1).webp",
    "order": 1,
    "alt": "The Cantilever metal facade project by Metaguise"
  },
  {
    "imgPath": "assets/Allprojects/residential/The Crest/cover/The Crest (1).webp",
    "order": 1,
    "alt": "The Crest metal facade project by Metaguise"
  },
  {
    "imgPath": "assets/Allprojects/residential/The Frame/cover/The Frame (1).webp",
    "order": 1,
    "alt": "The Frame metal facade project by Metaguise"
  },
  {
    "imgPath": "assets/Allprojects/residential/The Panorama/cover/The Panorama (1).webp",
    "order": 1,
    "alt": "The Panorama facade project by Metaguise"
  },
  {
    "imgPath": "assets/Allprojects/commercial/Rahul Sweets/cover/Rahul Sweets (1).webp",
    "order": 1,
    "alt": "Rahul Sweets commercial facade design by Metaguise"
  },
  {
    "imgPath": "assets/Allprojects/commercial/Achintya/cover/achintya_1.webp",
    "order": 1,
    "alt": "Achintya architectural facade project by Metaguise"
  },
  {
    "imgPath": "assets/Allprojects/residential/Casa Stilgrove/cover/casa_1.webp",
    "order": 1,
    "alt": "Casa Stilgrove facade project by Metaguise"
  },
  {
    "imgPath": "assets/Allprojects/residential/The Cornerstone/cover/nitiKa_1.webp",
    "order": 1,
    "alt": "The Cornerstone facade project by Metaguise"
  },
  {
    "imgPath": "assets/Allprojects/residential/The Golden Bloom/cover/coin_1.webp",
    "order": 1,
    "alt": "The Golden Bloom metal facade project by Metaguise"
  },
  {
    "imgPath": "assets/Allprojects/residential/The Stillwave/cover/Kunal_1.webp",
    "order": 1,
    "alt": "The Stillwave metal facade project by Metaguise"
  },
  {
    "imgPath": "assets/Allprojects/residential/The Haven/cover/rochak_1.webp",
    "order": 1,
    "alt": " The Haven contemporary facade project by Metaguise"
  },
  {
    "imgPath": "assets/Allprojects/residential/Apex Residence/cover/manish_1.webp",
    "order": 1,
    "alt": " Apex Residence residential facade design by Metaguise"
  },
  {
    "imgPath": "assets/Allprojects/commercial/Blossoms/cover/blossoms1.webp",
    "order": 1,
    "alt": "Blossoms commercial project cover - Commercial space with blossoming architectural design"
  },
  {
    "imgPath": "assets/Allprojects/commercial/Cityspace82/cover/cityspace82_1.webp",
    "order": 1,
    "alt": "Cityspace82 commercial project cover - Urban commercial development with metal facade"
  },
  {
    "imgPath": "assets/Allprojects/residential/88Arjun/cover/88_5.webp",
    "order": 1,
    "alt": "Parametric Crown metal facade design by Metaguise"
  },
  {
    "imgPath": "assets/Allprojects/residential/Verdigris Veil/cover/K3_1.webp",
    "order": 1,
    "alt": "Verdigris Veil architectural facade by Metaguise"
  },
  {
    "imgPath": "assets/Allprojects/residential/W12/cover/w12_1.webp",
    "order": 1,
    "alt": "W12 residential project cover - Contemporary villa with metal cladding system"
  },
  {
    "imgPath": "assets/Allprojects/residential/caskey/cover/caskey1.webp",
    "order": 1,
    "alt": "Kinetic Grid facade project by Metaguise"
  },
  {
    "imgPath": "assets/Allprojects/commercial/hlp/cover/hlp1.webp",
    "order": 1,
    "alt": "HLP metal facade project designed by Metaguise"
  },
  {
    "imgPath": "assets/Allprojects/commercial/sbi/cover/sbi1.webp",
    "order": 1,
    "alt": "SBI Bank facade design project by Metaguise"
  },
  {
    "imgPath": "assets/Allprojects/commercial/zenith/cover/zen1.webp",
    "order": 1,
    "alt": "Zenith architectural facade project by Metaguise"
  },
  {
    "imgPath": "assets/Allprojects/residential/3DLF1/cover/3dlf1_1.webp",
    "order": 1,
    "alt": "3DLF architectural facade project by Metaguise"
  },
  {
    "imgPath": "assets/Allprojects/residential/anj/cover/anj1.webp",
    "order": 1,
    "alt": "ANJ residential project cover - Modern home with custom metal shingle design"
  },
  {
    "imgPath": "assets/Allprojects/residential/pritesh/cover/pritesh1.webp",
    "order": 1,
    "alt": "Sacred Geometry metal facade design by Metaguise"
  },
  {
    "imgPath": "assets/Allprojects/residential/ishaan/cover/ishaan1.webp",
    "order": 1,
    "alt": "Peacock mesh metal facade design by Metaguise"
  },
  {
    "imgPath": "assets/Allprojects/residential/sachi/cover/sachi1.webp",
    "order": 1,
    "alt": "Sachi architectural facade project by Metaguise"
  },
  {
    "imgPath": "assets/Allprojects/residential/vivek/cover/vivek1.webp",
    "order": 1,
    "alt": "Obsidian architectural facade project by Metaguise"
  },
  {
    "imgPath": "assets/Allprojects/residential/dev622/cover/dev1.webp",
    "order": 1,
    "alt": "Monolith Garden architectural facade project by Metaguise"
  },
  {
    "imgPath": "assets/Allprojects/residential/PeachStreet/cover/peachstreet1.webp",
    "order": 1,
    "alt": "Peach Street architectural facade project by Metaguise"
  },
  {
    "imgPath": "assets/Allprojects/residential/CopperCanvas/cover/coppercanvas1.webp",
    "order": 1,
    "alt": "Copper facade design project Copper Canvas by Metaguise"
  },
  {
    "imgPath": "assets/Allprojects/residential/LinearRetreat/cover/linearretreat1.webp",
    "order": 1,
    "alt": "Linear Retreat architectural facade project by Metaguise"
  },
  {
    "imgPath": "assets/Allprojects/residential/TheResonance/cover/karan1.webp",
    "order": 1,
    "alt": "The Resonance residential project cover - Home with resonant metal architectural elements"
  },
  {
    "imgPath": "assets/Allprojects/residential/TheElevato/cover/neeraj1.webp",
    "order": 1,
    "alt": "The Elevato residential project cover - Elevated design with modern metal facade"
  },
  {
    "imgPath": "assets/Allprojects/commercial/TheCurtain/cover/vega1.webp",
    "order": 1,
    "alt": "The Curtain commercial project cover - Curtain-inspired metal facade for commercial space"
  },
  {
    "imgPath": "assets/Allprojects/residential/TheCrystal/cover/bikaner1.webp",
    "order": 1,
    "alt": "The Crystal residential project cover - Crystal-inspired architecture with metal cladding"
  },
  {
    "imgPath": "assets/Allprojects/residential/Farm15/cover/farm1.webp",
    "order": 1,
    "alt": "Farm15 residential project cover - Farmhouse with contemporary metal architecture"
  },
  {
    "imgPath": "assets/Allprojects/residential/E81/cover/e81_1.webp",
    "order": 1,
    "alt": "E81 residential project cover - Modern residence with parametric metal facade"
  },
  {
    "imgPath": "assets/Allprojects/residential/B38/cover/b38_1.webp",
    "order": 1,
    "alt": "B38 residential project cover - Contemporary home with custom metal cladding"
  },
  {
    "imgPath": "assets/Allprojects/residential/A56/cover/a56_1.webp",
    "order": 1,
    "alt": "A56 residential project cover - Modern villa with architectural metal design"
  },
  {
    "imgPath": "assets/Allprojects/commercial/Ardete/cover/ardete5.webp",
    "order": 1,
    "alt": "Ardete commercial project cover - Commercial building with innovative metal facade"
  },
  {
    "imgPath": "assets/Allprojects/residential/TheWaveform/cover/khandelwal1.webp",
    "order": 1,
    "alt": "The Waveform residential project cover - Wave-inspired metal architecture for modern home"
  },
  {
    "imgPath": "assets/Allprojects/commercial/Tanishq/cover/tanishq11.webp",
    "order": 2,
    "alt": "Tanishq commercial project cover - Jewelry showroom with premium metal architecture"
  },
  {
    "imgPath": "assets/Allprojects/residential/Luxe/cover/luxe16.webp",
    "order": 3,
    "alt": "Luxe residential project cover - Luxury residence with premium metal facade"
  },
  {
    "imgPath": "assets/Allprojects/residential/D5-3/cover/ankit1.webp",
    "order": 4,
    "alt": "D5-3 residential project cover - Contemporary home with metal shingle facade"
  },
  {
    "imgPath": "assets/Allprojects/commercial/Gowri/cover/gowri2.webp",
    "order": 5,
    "alt": "Gowri commercial project cover - Commercial space with elegant metal cladding"
  },
  {
    "imgPath": "assets/Allprojects/residential/Espace/cover/espace1.webp",
    "order": 6,
    "alt": "Espace residential project cover - Spacious residence with modern metal design"
  },
  {
    "imgPath": "assets/Allprojects/residential/A13-43/cover/a13-431.webp",
    "order": 7,
    "alt": "A13-43 residential project cover - Modern residence with geometric metal patterns"
  },
  {
    "imgPath": "assets/Allprojects/residential/Q62-RA/cover/tejbir1.webp",
    "order": 8,
    "alt": "Q62-RA residential project cover - Contemporary residence with metal cladding design"
  },
  {
    "imgPath": "assets/Allprojects/commercial/PremHospital/cover/prem1.webp",
    "order": 10,
    "alt": "Prem Hospital commercial project cover - Healthcare facility with contemporary metal facade"
  },
  {
    "imgPath": "assets/Allprojects/residential/A18/cover/a181.webp",
    "order": 11,
    "alt": "A18 residential project cover - Contemporary villa with metal facade system"
  },
  {
    "imgPath": "assets/Allprojects/commercial/Painflame/cover/15.webp",
    "order": 12,
    "alt": "Painflame commercial project cover - Commercial space with innovative metal design"
  },
  {
    "imgPath": "assets/Allprojects/commercial/Deepak/cover/deepak1.webp",
    "order": 14,
    "alt": "Deepak commercial project cover - Modern commercial building with metal accents"
  },
  {
    "imgPath": "assets/Allprojects/residential/A19/cover/a192.webp",
    "order": 18,
    "alt": "A19 residential project cover - Luxury residence with parametric metal design"
  },
  {
    "imgPath": "assets/Allprojects/residential/MVA-DL1/cover/varun5.webp",
    "alt": "MVA-DL1 residential project cover - Modern home with custom metal shingle design"
  },
  {
    "imgPath": "assets/Allprojects/residential/CS5-MA/cover/vishal1.webp",
    "order": 15,
    "alt": "CS5-MA residential project cover - Contemporary home with metal shingle architecture"
  },
  {
    "imgPath": "assets/Allprojects/commercial/Metaland/cover/metaland6.webp",
    "order": 20,
    "alt": "Metaland commercial project cover - Commercial development with extensive metal architecture"
  },
  {
    "imgPath": "assets/Allprojects/commercial/Micasa/cover/micasa1.webp",
    "order": 21,
    "alt": "Micasa commercial project cover - Modern commercial space with metal cladding"
  },
  {
    "imgPath": "assets/Allprojects/commercial/yashika/cover/yashika1.webp",
    "alt": "Yashika commercial project cover - Commercial building with contemporary metal facade"
  },
  {
    "imgPath": "assets/Allprojects/residential/5107/cover/51071.webp",
    "order": 13,
    "alt": "5107 residential project cover - Contemporary home with parametric metal shingles"
  },
  {
    "imgPath": "assets/Allprojects/residential/A297/cover/a2971.webp",
    "order": 16,
    "alt": "A297 residential project cover - Luxury villa with architectural metal facade"
  },
  {
    "imgPath": "assets/Allprojects/commercial/E10/cover/e105.webp",
    "order": 17,
    "alt": "E10 commercial project cover - Modern commercial building with metal architecture"
  },
  {
    "imgPath": "assets/Allprojects/residential/C76/cover/c7615.webp",
    "order": 22,
    "alt": "C76 residential project cover - Modern residence with textured metal design"
  },
  {
    "imgPath": "assets/Allprojects/residential/C34-573/cover/kapil1.webp",
    "order": 23,
    "alt": "C34-573 residential project cover - Modern home with custom metal cladding system"
  },
  {
    "imgPath": "assets/Allprojects/residential/DLF4/cover/dlf44.webp",
    "order": 24,
    "alt": "DLF4 residential project cover - Premium residence with elegant metal facade"
  },
  {
    "imgPath": "assets/Allprojects/residential/MA-543/cover/manoj1.webp",
    "order": 25,
    "alt": "MA-543 residential project cover - Modern villa with parametric metal facade"
  },
  {
    "imgPath": "assets/Allprojects/residential/z1012/cover/z10121.webp",
    "order": 26,
    "alt": "Z1012 residential project cover - Modern home with geometric metal patterns"
  }
];